"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainsService = void 0;
const tsyringe_1 = require("tsyringe");
const types_1 = require("../types");
const types_2 = require("./types");
const common_1 = require("@keplr-wallet/common");
const updater_1 = require("../updater");
const interaction_1 = require("../interaction");
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const cosmos_1 = require("@keplr-wallet/cosmos");
let ChainsService = class ChainsService {
    constructor(kvStore, embedChainInfos, chainUpdaterKeeper, interactionKeeper) {
        this.kvStore = kvStore;
        this.embedChainInfos = embedChainInfos;
        this.chainUpdaterKeeper = chainUpdaterKeeper;
        this.interactionKeeper = interactionKeeper;
        this.onChainRemovedHandlers = [];
        this.getChainInfos = common_1.Debouncer.promise(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.cachedChainInfos) {
                return this.cachedChainInfos;
            }
            const chainInfos = this.embedChainInfos.map((chainInfo) => {
                return Object.assign(Object.assign({}, chainInfo), { embeded: true });
            });
            const embedChainInfoIdentifierMap = new Map();
            for (const embedChainInfo of chainInfos) {
                embedChainInfoIdentifierMap.set(cosmos_1.ChainIdHelper.parse(embedChainInfo.chainId).identifier, true);
            }
            const savedChainInfos = ((_a = (yield this.kvStore.get("chain-infos"))) !== null && _a !== void 0 ? _a : [])
                .filter((chainInfo) => {
                // Filter the overlaped chain info with the embeded chain infos.
                return !embedChainInfoIdentifierMap.get(cosmos_1.ChainIdHelper.parse(chainInfo.chainId).identifier);
            })
                .map((chainInfo) => {
                return Object.assign(Object.assign({}, chainInfo), { embeded: false });
            });
            let result = chainInfos.concat(savedChainInfos);
            // Set the updated property of the chain.
            result = yield Promise.all(result.map((chainInfo) => __awaiter(this, void 0, void 0, function* () {
                const updated = yield this.chainUpdaterKeeper.putUpdatedPropertyToChainInfo(chainInfo);
                return Object.assign(Object.assign({}, updated), { embeded: chainInfo.embeded });
            })));
            this.cachedChainInfos = result;
            return result;
        }));
    }
    clearCachedChainInfos() {
        this.cachedChainInfos = undefined;
    }
    getChainInfo(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = (yield this.getChainInfos()).find((chainInfo) => {
                return (cosmos_1.ChainIdHelper.parse(chainInfo.chainId).identifier ===
                    cosmos_1.ChainIdHelper.parse(chainId).identifier);
            });
            if (!chainInfo) {
                throw new router_1.KeplrError("chains", 411, `There is no chain info for ${chainId}`);
            }
            return chainInfo;
        });
    }
    getChainCoinType(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.getChainInfo(chainId);
            if (!chainInfo) {
                throw new router_1.KeplrError("chains", 411, `There is no chain info for ${chainId}`);
            }
            return chainInfo.bip44.coinType;
        });
    }
    hasChainInfo(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return ((yield this.getChainInfos()).find((chainInfo) => {
                return (cosmos_1.ChainIdHelper.parse(chainInfo.chainId).identifier ===
                    cosmos_1.ChainIdHelper.parse(chainId).identifier);
            }) != null);
        });
    }
    suggestChainInfo(env, chainInfo, origin) {
        return __awaiter(this, void 0, void 0, function* () {
            chainInfo = yield types_2.ChainInfoSchema.validateAsync(chainInfo, {
                stripUnknown: true,
            });
            yield this.interactionKeeper.waitApprove(env, "/suggest-chain", messages_1.SuggestChainInfoMsg.type(), Object.assign(Object.assign({}, chainInfo), { origin }));
            yield this.addChainInfo(chainInfo);
        });
    }
    addChainInfo(chainInfo) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.hasChainInfo(chainInfo.chainId)) {
                throw new router_1.KeplrError("chains", 121, "Same chain is already registered");
            }
            const savedChainInfos = (_a = (yield this.kvStore.get("chain-infos"))) !== null && _a !== void 0 ? _a : [];
            savedChainInfos.push(chainInfo);
            yield this.kvStore.set("chain-infos", savedChainInfos);
            this.clearCachedChainInfos();
        });
    }
    removeChainInfo(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.hasChainInfo(chainId))) {
                throw new router_1.KeplrError("chains", 120, "Chain is not registered");
            }
            if ((yield this.getChainInfo(chainId)).embeded) {
                throw new router_1.KeplrError("chains", 122, "Can't remove the embedded chain");
            }
            const savedChainInfos = (_a = (yield this.kvStore.get("chain-infos"))) !== null && _a !== void 0 ? _a : [];
            const resultChainInfo = savedChainInfos.filter((chainInfo) => {
                return (cosmos_1.ChainIdHelper.parse(chainInfo.chainId).identifier !==
                    cosmos_1.ChainIdHelper.parse(chainId).identifier);
            });
            yield this.kvStore.set("chain-infos", resultChainInfo);
            // Clear the updated chain info.
            yield this.chainUpdaterKeeper.clearUpdatedProperty(chainId);
            for (const chainRemovedHandler of this.onChainRemovedHandlers) {
                chainRemovedHandler(chainId, cosmos_1.ChainIdHelper.parse(chainId).identifier);
            }
            this.clearCachedChainInfos();
        });
    }
    addChainRemovedHandler(handler) {
        this.onChainRemovedHandlers.push(handler);
    }
};
ChainsService = __decorate([
    tsyringe_1.singleton(),
    __param(0, tsyringe_1.inject(types_1.TYPES.ChainsStore)),
    __param(1, tsyringe_1.inject(types_1.TYPES.ChainsEmbedChainInfos)),
    __param(2, tsyringe_1.inject(tsyringe_1.delay(() => updater_1.ChainUpdaterService))),
    __param(3, tsyringe_1.inject(tsyringe_1.delay(() => interaction_1.InteractionService))),
    __metadata("design:paramtypes", [Object, Array, updater_1.ChainUpdaterService,
        interaction_1.InteractionService])
], ChainsService);
exports.ChainsService = ChainsService;
//# sourceMappingURL=service.js.map